$(document).ready(function() {
    $('#newsletter-form').on('submit', function(e) {
        e.preventDefault();

        var email = $('.newsletter').val();

        // Simple email validation - laravel validates on backend too
        if(email.length < 4 || !email.includes('@')) {
            $('.newsletter-error-txt').html('Please enter a valid email address.')
            return;
        }

        $.ajax({
            url: '/submit-newsletter',
            type: 'POST',
            data: {
                email: email,
            },
            success: function(response) {
                $('.newsletter-container').fadeOut('slow', function() {
                    $(this).addClass('hidden');
                    $('.newsletter-title').addClass('hidden');
                    $('.newsletter-success-txt').hide().removeClass('hidden').fadeIn('slow');
                });
            },
            
            error: function() {
                // Error feedback
                $('.newsletter-error-txt').html('An error occurred, please try again.')
            }
        });
    });
});